import Reveal from "@/components/Reveal";

export default function TheProblem() {
  return (
    <section
      className="bg-ink-2 relative border-t border-white/[0.06]"
      data-testid="the-problem-section"
    >
      <div className="container-edge py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-x-8 gap-y-8">
          <Reveal className="col-span-12 lg:col-span-5">
            <div className="eyebrow">The problem</div>
            <h2
              className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.75rem] tracking-tight mt-4 text-parchment-bright leading-[1.05]"
              data-testid="the-problem-headline"
            >
              Patient voice is everywhere.
              <span className="block italic text-parchment-bright">Evidence is not.</span>
            </h2>
          </Reveal>

          <Reveal className="col-span-12 lg:col-span-7 lg:pt-2" delay={120}>
            <p
              className="text-parchment/80 text-lg leading-relaxed max-w-xl"
              data-testid="the-problem-body"
            >
              Patient insights are scattered across social conversations, patient communities, advisory discussions, real-world evidence, and published research. Most organisations struggle to translate these fragmented signals into actionable strategy.
            </p>
            <div className="mt-8 pt-7 border-t border-white/[0.10] max-w-xl">
              <p className="font-serif text-2xl text-parchment-bright italic leading-snug">
                Voice2Evidence bridges that gap.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
